import React from "react";
import "./App.css";

function Contact() {
  return <div id="contact" />;
}
export default Contact;



// WEBPACK FOOTER //
// ./src/contact.js